module.exports = __webpack_public_path__ + "static/media/statistics-mobile-right-top-bg.0d49b1a6.svg";